import { useCallback, useEffect, useRef } from "react";

import { scrollMessageToCenter } from "./messageScroll";

/** How long the ring stays on a message after "Anzeigen". */
export const SHOW_MESSAGE_RING_MS = 2500;

/**
 * "Anzeigen" on a send entry: the forwarded message scrolls to the centre and takes the same
 * transient ring as a deep link. The timer is the only thing that outlives the click: a second
 * click restarts it (the first one must not clear the new ring), and leaving the ticket cancels it.
 */
export function useShowMessage(
  setRingId: (messageId: string | null) => void,
): (messageId: string) => void {
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(
    () => () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    },
    [],
  );
  return useCallback(
    (messageId: string) => {
      scrollMessageToCenter(messageId);
      setRingId(messageId);
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(
        () => setRingId(null),
        SHOW_MESSAGE_RING_MS,
      );
    },
    [setRingId],
  );
}
